// Faixa acima da grade: cliente identificado (chip com carteira) ou o convite
// "Ganhe X% de cashback · informe seu CPF". Some quando não há nada a mostrar.
// Usada pelo cardápio do Totem e pelo do Balcão.
import { Coins } from "lucide-react";

import PremioNoBalcao from "../../cartao-fidelidade/PremioNoBalcao";

export default function FaixaCliente({ ctx }) {
  const { chipCliente, setScreen, setEtapaIdent, cashbackAtivo, cashbackCfg, cliente, customerName, autoAtendimento, cart, desconto } = ctx;
  const temFaixa = !!(cliente || (customerName || "").trim() || (cashbackAtivo && !cliente));
  if (!temFaixa) return null;
  return (
    <div className="bg-zinc-900/50 border-b border-zinc-800 px-4 py-2.5 flex items-center gap-3" data-e2e="faixa-cliente">
      {chipCliente()}
      {/* Cartão Fidelidade: carimbos do cliente e o prêmio a usar (23/10/2026) */}
      {cliente?.id && <PremioNoBalcao cliente={cliente} canal={autoAtendimento ? "Totem" : "Balcao"} carrinho={cart} desconto={desconto} />}
      {cashbackAtivo && !cliente && (
        <button type="button" onClick={() => { setEtapaIdent("cpf"); setScreen("identificacao"); }} data-e2e="faixa-cashback" className="flex items-center gap-2 rounded-full bg-emerald-500/15 border border-emerald-500/40 px-3 py-1.5 text-sm font-semibold text-emerald-300 active:scale-95 transition-transform">
          <Coins className="w-4 h-4" /> Ganhe {String(cashbackCfg?.percentual).replace(".", ",")}% de cashback · informe seu CPF
        </button>
      )}
    </div>
  );
}
